import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHourglassState } from '../../../redux/actions/hourglassAction';

/**
 * Implementation extracted from LeftWorkUpload.js as it will be reused in 
 * MobileView Footer
 */
export const usePickedImages = (onImageLoaded:(success:boolean)=>void) => {
    const dispatch = useDispatch();

    const makFabric = useSelector((state: any) => state.makFabric)

    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            const reader = new FileReader()
            dispatch(setHourglassState(true))
            reader.readAsDataURL(acceptedFiles[0])
            reader.onload = (e: any) => {
                const image = e?.target?.result
                if(!image){
                    onImageLoaded(false);
                    dispatch(setHourglassState(false))
                    return
                }
                if (acceptedFiles[0].type !== "application/pdf") {
                    makFabric.addImage(image)
                    dispatch(setHourglassState(false))
                    onImageLoaded(true);
                } else {
                    (window as any).PDFJS.getDocument(image).then(function (pdf:any) {
                        let numberOfPage = 1

                        pdf.getPage(numberOfPage).then(function (page:any) {
                            let viewport = page.getViewport(1.0)
                            let canvasEl = document.createElement("canvas")
                            let borderWidth = 2
                            canvasEl.height = viewport.height + borderWidth
                            canvasEl.width = viewport.width + borderWidth
                            canvasEl.getContext("2d")?.translate(-borderWidth, -borderWidth)

                            page
                                .render({
                                    canvasContext: canvasEl.getContext("2d"),
                                    viewport: viewport,
                                })
                                .then(function () {
                                    let bg = canvasEl.toDataURL("image/png", 0.5)
                                    makFabric.addImage(bg)
                                    dispatch(setHourglassState(false))
                                    onImageLoaded(false);
                                })
                        })
                    })
                }
            }
        },
        [makFabric, dispatch, onImageLoaded],
    )
    return onDrop
}